import { Pipe, PipeTransform } from '@angular/core';
import { ProjectPhaseEnum } from '../../enums/project-phase.enum';

// Mapping enum values to user-friendly labels
export const ProjectPhaseLabels: { [key: number]: string } = {
    [ProjectPhaseEnum.Schetsontwerp]: 'Schetsontwerp',
    [ProjectPhaseEnum.VoorlopigOntwerp]: 'Voorlopig ontwerp',
    [ProjectPhaseEnum.DefinitiefOntwerp]: 'Definitief ontwerp',
    [ProjectPhaseEnum.Vergunningaanvraag]: 'Vergunningaanvraag',
    [ProjectPhaseEnum.Oplevering]: 'Oplevering'
};

@Pipe({
    name: 'phaseLabel',
    standalone: false
})
export class PhaseLabelPipe implements PipeTransform {
    transform(value: number | undefined | null): string {
        if (typeof value !== 'number' || value == null || value <= 0) {
            return 'Unknown';
        }
        return ProjectPhaseLabels[value] ?? 'Unknown';
    }
}
